import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Router, RouterModule } from '@angular/router';
import { Medium } from '../medium.model';
import { MediaService } from '../media.service';
import { FormMessage } from 'src/app/ui-design-library/form-message/form-message.model';
import { LoadComponent } from 'src/app/ui-design-library/load/load.component';
import { IconComponent } from 'src/app/ui-design-library/icon/icon.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'fnsr-medium-list',
  standalone: true,
  imports: [LoadComponent, IconComponent, AsyncPipe, RouterModule],
  templateUrl: './medium-list.component.html',
  styleUrls: ['./medium-list.component.scss']
})
export class MediumListComponent {
  mediums$: Observable<Medium[]>
  formMessage?: FormMessage;

  constructor(
    public mediaService: MediaService,
    public router: Router
  ) {
    this.mediums$ = this.mediaService.getMedia();
  }
}
